<section>
  <div>
    <div class="container">
      <dev-together-form
        [data$]="data$"
        [form$]="form$"
        (updateForm)="onFormUpdate($event)"
      >
      </dev-together-form>

      <ng-content select="[paragraph]"></ng-content>

      <dev-together-errors></dev-together-errors>

      <ng-content select="[dev-together-button-retro]"></ng-content>
    </div>
  </div>
</section>
